<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="itemsField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeItemsField] ? 'Exclude' : 'Include')} Items`"
      :options="filteredItems"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      use-input
      input-style="search"
      input-debounce="100"
      clearable
      bottom-slots
      :rules="[
        val => !!val || 'Field is required'
      ]"
      @filter="filterItems"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeItemsField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'ItemsConditionForm',
  configuration: ['items'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    itemsField: {
      type: String,
      default: CONDITION_REQUIREMENTS.ITEMS
    },
    excludeItemsField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_ITEMS
    }
  },
  data () {
    return {
      itemSearchString: ''
    }
  },
  computed: {
    filteredItems () {
      return _.filter(this.items.data, item => item.name.toLowerCase().includes(this.itemSearchString))
    }
  },
  methods: {
    filterItems (val, update, abort) {
      update(() => {
        this.itemSearchString = val.toLowerCase()
      })
    }
  }
}

</script>
